<template>
    <div class="payment">
        <form :action="url" ref="form" method="post">
            <input v-for="(val, key) in data" type="hidden" :name="key" :value="val" :key="key">
        </form>
    </div>
</template>

<script>
    import * as apis from '../apis';
    import Swal from 'sweetalert2';

    export default {
        name: 'Payment',
        data() {
            return {
                url: null,
                data: [],
            }
        },
        created() {
            let orderId = this.$route.params.id;
            if (!orderId) {
                window.close();
            }

            let payload = {
                order_id: orderId,
            };

            apis.getPaymentFormData(payload).then(res => {
                this.url = res.data.url;
                this.data = res.data.data;
                this.$nextTick(() => {
                    this.$refs.form.submit();
                })
            }).catch(err => {
                Swal.fire({
                    type: 'error',
                    title: 'Oops...',
                    text: err.response.data.message,
                    allowOutsideClick: false,
                    showConfirmButton: true,
                }).then(() => {
                    window.close();
                });
            })
        }
    };
</script>

<style scoped>
</style>
